import {
    type IncomeSplitOverviewData,
    incomeSplitOverviewDataAtom,
} from '@fruitful/income-split';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { requestBuilder } from '../../../../http/RequestBuilder';

const useFetchIncomeSplitOverview =
    requestBuilder.query<IncomeSplitOverviewData>({
        endpoint: () => '/api/income-split/overview',
        queryKey: () => 'getIncomeSplitOverview',
    });

export const useGetIncomeSplitOverviewFromGlobalState = () => {
    const [incomeSplitOverviewData, setIncomeSplitOverviewData] = useAtom(
        incomeSplitOverviewDataAtom,
    );

    const { data, isLoading, isError, error } = useFetchIncomeSplitOverview({});

    useEffect(() => {
        if (!isLoading && data) setIncomeSplitOverviewData(data);
    }, [data, isLoading, setIncomeSplitOverviewData]);

    // React Query is the source of truth for the current request. The atom is
    // updated in an effect, so returning only the atom creates a render where
    // loading has finished but data is still null. Use the atom as a warm cache
    // only while the current query has no data.
    const resolvedData = data ?? incomeSplitOverviewData;

    return {
        data: resolvedData,
        isLoading: isLoading && resolvedData == null,
        isError: isError && resolvedData == null,
        error,
    };
};
